import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/default-user.png'


_pushScopeId("data-v-cbc0e1b4")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "user"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "first-bar" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "second-bar" }, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["alt"]
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "email" }
const _hoisted_10 = {
  key: 0,
  class: "role"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createBlock(_component_base_card, { class: "card-user" }, {
    default: _withCtx(() => [
      (!_ctx.user)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t('noData')), 1))
        : _createCommentVNode("", true),
      (_ctx.user)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass(["icon-user", { activated: _ctx.user.activated }])
            }, _hoisted_5, 2),
            _createElementVNode("div", {
              class: "logo",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToUser()))
            }, [
              (_ctx.src)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "img",
                    src: _ctx.src,
                    alt: _ctx.$t('logo')
                  }, null, 8, _hoisted_6))
                : _createCommentVNode("", true),
              (!_ctx.src)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "img",
                    src: _imports_0,
                    alt: _ctx.$t('logo')
                  }, null, 8, _hoisted_7))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h1", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToUser()))
              }, _toDisplayString(_ctx.user.username), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.user.email), 1),
              (_ctx.user.role)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t(`Roles.${_ctx.user.role}`)), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}